module.exports = __webpack_public_path__ + "img/crm.d642a7a0.png";